const FishIdentification = () => import('Views/characteristic/fish-identification');

export default[
  { path: '/characteristic/fish-identification', component: FishIdentification },
];



// WEBPACK FOOTER //
// ./src/router/fishIdentification.js